export const genderSalutation = (gender) => {
  if (gender === 'MR') return 'Sehr geehrter Herr';
  if (gender === 'MRS') return 'Sehr geehrte Frau';
  if (gender === 'FAMILY') return 'Sehr geehrte Familie';
  return 'Sehr geehrte Damen und Herren';
};
